type ConvertibleValue = string | number | object | boolean;

export const convertArrayToObject = (
  arr: ConvertibleValue[]
): Record<string, ConvertibleValue> =>
  arr.reduce<Record<string, ConvertibleValue>>(
    (acc, curr) => ({ ...acc, [curr as string]: curr }),
    {}
  );
